import Link from 'next/link';

import { cn } from '@utils/cn';

type InternalLinkProps = {
  children: React.ReactNode;
  className?: string;
  href: string;
  story?: any;
  target: string;
};

export function InternalLink({ children, className, href, target }: InternalLinkProps) {
  return (
    <Link
      className={cn('underline', className)}
      href={href}
      target={target}
    >
      {children}
    </Link>
  );
}
